import { MODULE as PARENT } from '../constants'

export const KEY = 'post'
export const MODULE = [...[PARENT], KEY]

export const FETCH_POSTS_LIST = `${MODULE.join('/')}s-list-fetch`
export const FETCH_RECENT_POSTS = `${MODULE.join('/')}s-recent-fetch`
export const FETCH_POST = `${MODULE.join('/')}-fetch`
export const CLEAR_POSTS = `${MODULE.join('/')}-clear`
